import type React from "react"

interface StepIndicatorProps {
  currentStep?: number
  totalSteps?: number
  stepLabel?: string
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep = 7, totalSteps = 7, stepLabel = "Syncing" }) => (
  <div className="step-indicator">
    {Array.from({ length: totalSteps }, (_, index) => (
      <span
        key={index + 1}
        className={`sync-step ${index + 1 < currentStep ? "completed" : index + 1 === currentStep ? "active" : ""}`}
      >
        {index + 1}
      </span>
    ))}
    <span className="step-label">{stepLabel}</span>
  </div>
)

export default StepIndicator
